import { useEffect } from 'react';

// Tanımlı olmayan bir rotaya girilince, IsoSofts'un uzay temalı 404 sayfasına
// (gerçek HTTP 404 — container nginx'i /not-found için 404 döndürür) yönlendir.
export function NotFoundPage() {
  useEffect(() => {
    window.location.replace('/not-found');
  }, []);
  return null;
}
